import { baseUrl } from '../config';
export const getLoginUrl = (redirectPath: string): string =>
  `${baseUrl}/login/oauth2/authorization/oidc?redirectUrl=${redirectPath}`;
